

















































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { RootStoreState } from '../../store';
import FeedbackDialog from './feedbackDialog.vue';
// tslint:disable-next-line:no-unused
declare var feedbackWorkspace: Function;

@Component({
  components: {
    FeedbackDialog,
  },
})
export default class MswAppFooter extends SwExtendedVue {
  buildVersion: string = '';
  showFeedBackDialog: boolean = false;
  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  onLinkClick(menu: string) {
    switch (menu) {
      case 'downloads':
        if (this.loggedIn) {
          this.$router.push({ path: '/m/feature/freedownloads' });
        } else {
          this.$router.push({ path: '/g/freedownloads' });
        }
        break;

      case 'reportIssues':
        this.navigateToReportIssues();
        break;

      case 'securityCenter':
        window.open('https://securitycenter.sonicwall.com', '_blank');
        break;

      case 'demos':
        window.open('http://livedemo.sonicwall.com/', '_blank');
        break;

      case 'release':
        window.open('https://www.sonicwall.com/support/technical-documentation/docs/msw-release_notes/Content/release_notes.htm', '_blank');
        break;

      case 'register':
        this.$router.push({ path: '/m/feature/register-products' });
        break;

      case 'tos':
        if (this.loggedIn) {
          this.$router.push({ path: '/m/feature/tos' });
        } else {
          this.$router.push({ path: '/g/tos' });
        }
        break;

      case 'privacy':
        window.open('https://www.sonicwall.com/legal/privacy-statement/', '_blank');
        break;
        // this.navigateToPrivacy();
        // break;

      case 'feedback':
        this.showFeedBackDialog = true;
        break;
    }
  }
  feedbackWorkspace() {
    this.showFeedBackDialog = true;
  }
  mounted() {
    this.getAppVersion();
  }
  getAppVersion() {
    this.$store.dispatch('getAppVersion')
    .then((res: any) => {
      this.activateAnalyticsService(res);
      this.$store.commit('setAppVersionContent', res.content);
      if (res.operationStatus === 'OK') {
        this.buildVersion = res.content.appVersion;
        if (res.content.buynowMode) {
          try {
            localStorage.setItem('buynowMode', res.content.buynowMode);
          } catch (e) {
            console.error(e);
          }
        }
        let isaccountsmswredirect = 'NO';
        if (res.content.isaccountsmswredirect) {
          isaccountsmswredirect = (res.content.isaccountsmswredirect) || 'NO';
        } else {
          isaccountsmswredirect = 'NO';
        }
        localStorage.setItem('isaccountsmswredirect', JSON.stringify(isaccountsmswredirect));
        let isPSAallowEmptyAgreement = 'NO';
        if (res.content.psaallowEmptyAgreement) {
          isPSAallowEmptyAgreement = (res.content.psaallowEmptyAgreement) || 'NO';
        } else {
          isPSAallowEmptyAgreement = 'NO';
        }
        localStorage.setItem('isPSAallowEmptyAgreement', JSON.stringify(isPSAallowEmptyAgreement));
        if (process.env.version && process.env.version.length > 0) {
          this.buildVersion = `${this.buildVersion}.${process.env.version}`;
        }
      }
    });
  }

  activateAnalyticsService(res: any) {
    if (res.content.hasOwnProperty('appMonitorUrl')) {
      if (res.content.appMonitorUrl !== '' || res.content.appMonitorUrl !== undefined) {
        // @ts-ignore
        localStorage.setItem('sendAnalyticData', true);
      }
    } else {
      // @ts-ignore
      localStorage.setItem('sendAnalyticData', false);
    }
  }

  navigateToReportIssues() {
    if (this.loggedIn) {
      this.$router.push({ path: '/m/feature/reportissues' });
    } else {
      this.$router.push({ path: '/g/reportissues' });
    }
  }

  navigateToPrivacy() {
    if (this.loggedIn) {
      this.$router.push({ path: '/m/feature/privacy' });
    } else {
      this.$router.push({ path: '/g/privacy' });
    }
  }
}
